export enum MapSelectionMode {
  LASSO = 'LASSO',
  MULTI_SELECT = 'MULTI_SELECT',
  RING = 'RING'
}
